import { Channel, ChatRoom, ChatRoomType } from '@dinosband/bv-main-schema/dist/types'
import { BvDataCenter, SubscriptionManager, ChatRoomAddedPayload, CHAT_ROOM_ADDED } from '@dinosband/bv-data-center'

import { MessengerContext, MessengerVuex, ChatRoomController } from '..'
import { ChatRoomStorePool } from './chat-room-store-pool'
import { ChatRoomContextPool } from './chat-room-context-pool'
import { HomelessChatRoomContexts } from './chat-room-homeless'

const _DEBUG_LOG = process.env.NODE_ENV !== 'production' &&
                   !!process.env.VUE_APP_MESSENGER_DEBUG_LOG

export class ChatRoomControllerPool {

  context: MessengerContext
  vuexStore: MessengerVuex
  dataCenter: BvDataCenter
  chatRoomStorePool: ChatRoomStorePool
  chatRoomContextPool: ChatRoomContextPool
  homelessChatRoomContexts: HomelessChatRoomContexts

  private subscriptions = new SubscriptionManager()

  constructor (context: MessengerContext, dataCenter: BvDataCenter) {
    this.context = context
    this.vuexStore = this.context.vuexStore
    this.dataCenter = dataCenter
    this.chatRoomStorePool = new ChatRoomStorePool(context)
    this.chatRoomContextPool = new ChatRoomContextPool(context)
    this.homelessChatRoomContexts = new HomelessChatRoomContexts(context)
    this.initSubscribe()
  }

  private initSubscribe () {
    this.subscriptions.init(this.context.pubsub)
    this.subscriptions.subscribe(CHAT_ROOM_ADDED, (info: ChatRoomAddedPayload) => {
      if (info.channelId && 0 < info.channelId) {
        // ignore channel chat-rooms excepts comments type
        if (![ChatRoomType.HELPDESK, ChatRoomType.COMMENTS].includes(info.type)) {
          return
        }
      }
      const ignoreController = info.channelId != null && info.channelId < 0
      this.initChatRooms(info.chatRooms, undefined, ignoreController)
    })
  }

  prepare () {
    this.chatRoomStorePool.prepare()
  }

  async init () {
    await this.homelessChatRoomContexts.init()
  }

  cleanup () {
    this.chatRoomStorePool.cleanup()
    this.chatRoomContextPool.cleanup()
    this.homelessChatRoomContexts.cleanup()
    const controllers = [...this.vuexStore.state.chatRoomController.controllers]
    controllers.forEach((i) => this.deinitController(i, true))
  }

  async initChatRooms (chatRooms: ChatRoom[], channel: Channel | undefined, ignoreController?: boolean) {
    await Promise.all(chatRooms.map(async (i) => {
      await this._initChatRoom(i, channel, ignoreController)
    }))
  }

  private async _initChatRoom (chatRoom: ChatRoom, channel: Channel | undefined, ignoreController?: boolean) {
    const chatRoomId = chatRoom.id
    const store = this.chatRoomStore(chatRoomId)
    store.init(chatRoom)
    store.channel = channel
    const context = this.chatRoomContext(chatRoomId)
    context.init(store)
    if (!ignoreController) {
      await this.initController(chatRoom)
    }
  }

  deinitChatRoom (chatRoomId: number) {
    // 지우지 말고 보관하고 있다가 필요할 때 사용하자
    // this.chatRoomStorePool.deinitStore(chatRoomId)
    const controller = this.chatRoomController(chatRoomId)
    if (controller) {
      this.deinitController(controller)
    }
  }

  chatRoomStore (chatRoomId: number) {
    return this.chatRoomStorePool.store(chatRoomId)
  }

  chatRoomContext (chatRoomId: number) {
    return this.chatRoomContextPool.context(chatRoomId)
  }

  chatRoomController (chatRoomId: number): ChatRoomController {
    return this.context.vuexStore.getters['chatRoomController/controller'](chatRoomId)
  }

  private async initController (chatRoom: ChatRoom) {
    const chatRoomId = chatRoom.id
    let controller = this.chatRoomController(chatRoomId)
    if (!controller) {
      const chatRoomContext = this.chatRoomContext(chatRoomId)
      controller = new ChatRoomController(chatRoomId, this.dataCenter, chatRoomContext)
      this.context.vuexStore.commit('chatRoomController/addController', controller)
    }
    await controller.init()
  }

  private deinitController (controller: ChatRoomController, destroy?: boolean) {
    if (destroy) {
      this.context.vuexStore.commit('chatRoomController/removeController', controller.chatRoomId)
    }
    if (controller.started) {
      controller.stop()
    }
    controller.deinit()
  }

  async initChannelChatRooms (channel: Channel) {
    // let chatRooms: ChatRoom[] = []
    // if (this.context.mainStore.isJoined(channel)) {
    //   const chatRoomIds = channel.chatRoomMenus.flatMap((i) => i.chatRoomId ?? [])
    //   chatRooms = chatRoomIds.flatMap((i) => this.dataCenter.chatRoom(i) ?? [])
    // } else {
    const chatRooms = channel.chatRoomMenus.flatMap((i) => i.chatRoom ?? [])
    // }
    await this.initChatRooms(chatRooms, channel)
  }

  cleanupChannelChatRooms (channelId: number) {
    const chatRoomIds = this.context.mainStore.getChatRoomMenusOfChannel(channelId).flatMap((i) => i.chatRoomId ?? [])
    chatRoomIds.forEach((i) => this.deinitChatRoom(i))
  }

}